import './section3.scss'

import { useTranslation } from 'react-i18next'

export const useSection3 = () => {
  const { t } = useTranslation()

  return {
    t,
  }
}
